import moment from "moment";
import {
  logout,
  login,
  forgotPassword,
  passwordReset,
} from "../services/user/auth";
import {
  ForgotPasswordResponse,
  LoginRequest,
  LoginResponse,
  PasswordResetRequest,
  PasswordResetResponse,
} from "../@types/Auth";

export default function useAuth() {
  function getToken(): string | null {
    const authTokenName = "auth_token";
    return localStorage.getItem(authTokenName);
  }

  function isAuthenticated(): boolean {
    const storedToken = localStorage.getItem("auth_token");
    const storedCreatedAt = localStorage.getItem("auth_token_created_at");

    if (!storedToken || !storedCreatedAt) {
      return false;
    }

    const tokenCreatedMoment = moment(+storedCreatedAt);
    const diffInDays = moment().diff(tokenCreatedMoment, "d");

    return diffInDays < 30;
  }

  async function destroySession(): Promise<void> {
    await logout();
    localStorage.clear();
    return window.location.replace("/login");
  }

  async function redirectUnauthenticatedUser(): Promise<void> {
    const isAuth = isAuthenticated();

    if (!isAuth) {
      return window.location.replace("/login");
    }
  }

  function doLogin(data: LoginRequest): Promise<LoginResponse | null> {
    return login(data);
  }

  function doForgotPassword(
    email: string
  ): Promise<ForgotPasswordResponse | null> {
    return forgotPassword(email);
  }

  function doPasswordReset(
    data: PasswordResetRequest
  ): Promise<PasswordResetResponse | null> {
    return passwordReset(data);
  }

  return {
    getToken,
    isAuthenticated,
    destroySession,
    redirectUnauthenticatedUser,
    doLogin,
    doForgotPassword,
    doPasswordReset,
  };
}
